export default __webpack_public_path__ + "static/media/ZETON_WEJSCIE.74244495.png";